import { HStack, Text } from '@chakra-ui/react';
import { DosageFormIcon } from '@novaheal/types';
import {
  CapsuleSolidIcon,
  CreamSolidIcon,
  DripSolidIcon,
  DropsSolidIcon,
  EmulsionSolidIcon,
  InfusionSolidIcon,
  InhalerSolidIcon,
  InjectionSolidIcon,
  JuiceSolidIcon,
  OintmentSolidIcon,
  PillSolidIcon,
  PlasterSolidIcon,
  PowderSolidIcon,
  SpraySolidIcon,
  SuppositorySolidIcon,
} from 'assets/icons/v2';
import { TooltipWithTouch } from 'components/common/TooltipWithTouch';
import { NovaIcon } from 'components/ui/novaIcon';
import { ReactElement } from 'react';

type ApplicationTypeIconProps = {
  dosageFormIcon: DosageFormIcon;
};

const ApplicationTypeIcon = ({ dosageFormIcon }: ApplicationTypeIconProps): ReactElement => {
  const getIcon = (): ReactElement | null => {
    switch (dosageFormIcon) {
      case DosageFormIcon.SUPPOSITORY:
        return <NovaIcon icon={SuppositorySolidIcon} size="l" color="icon.secondary" />;
      case DosageFormIcon.DRIP:
        return <NovaIcon icon={DripSolidIcon} size="l" color="icon.secondary" />;
      case DosageFormIcon.PILL:
        return <NovaIcon icon={PillSolidIcon} size="l" color="icon.secondary" />;
      case DosageFormIcon.JUICE:
        return <NovaIcon icon={JuiceSolidIcon} size="l" color="icon.secondary" />;
      case DosageFormIcon.SPRAY:
        return <NovaIcon icon={SpraySolidIcon} size="l" color="icon.secondary" />;
      case DosageFormIcon.OINTMENT:
        return <NovaIcon icon={OintmentSolidIcon} size="l" color="icon.secondary" />;
      case DosageFormIcon.CREAM:
        return <NovaIcon icon={CreamSolidIcon} size="l" color="icon.secondary" />;
      case DosageFormIcon.EMULSION:
        return <NovaIcon icon={EmulsionSolidIcon} size="l" color="icon.secondary" />;
      case DosageFormIcon.PLASTER:
        return <NovaIcon icon={PlasterSolidIcon} size="l" color="icon.secondary" />;
      case DosageFormIcon.INFUSION:
        return <NovaIcon icon={InfusionSolidIcon} size="l" color="icon.secondary" />;
      case DosageFormIcon.INJECTION:
        return <NovaIcon icon={InjectionSolidIcon} size="l" color="icon.secondary" />;
      case DosageFormIcon.POWDER:
        return <NovaIcon icon={PowderSolidIcon} size="l" color="icon.secondary" />;
      case DosageFormIcon.INHALER:
        return <NovaIcon icon={InhalerSolidIcon} size="l" color="icon.secondary" />;
      case DosageFormIcon.CAPSULE:
        return <NovaIcon icon={CapsuleSolidIcon} size="l" color="icon.secondary" />;
      case DosageFormIcon.DROPS:
        return <NovaIcon icon={DropsSolidIcon} size="l" color="icon.secondary" />;
      default:
        return null;
    }
  };
  return (
    <TooltipWithTouch hasArrow label={<Text>{dosageFormIcon}</Text>}>
      {getIcon()}
    </TooltipWithTouch>
  );
};

type ApplicationTypeIconsProps = {
  dosageFormIcons: DosageFormIcon[];
};

const MedicationApplicationTypeIcons = ({
  dosageFormIcons,
}: ApplicationTypeIconsProps): ReactElement => {
  return (
    <HStack gap="5px">
      {dosageFormIcons.map((dosageFormIcon) => (
        <ApplicationTypeIcon key={dosageFormIcon} dosageFormIcon={dosageFormIcon} />
      ))}
    </HStack>
  );
};

export default MedicationApplicationTypeIcons;
